import api from '../api';

import { ParamsBodyUpdatePlate } from 'utils/typeServices';

type ParamsResponse = {
    Data: string;
}

export const PostUpdatePlate = async ({ token, body }: { token: string, body: ParamsBodyUpdatePlate }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Plataforma/UpdatePlate', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
